module.exports = __webpack_public_path__ + "static/img/4bg_15.bb88ef1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_15.png
// module id = 700
// module chunks = 1